export function mixin() {
  return {
    data() {
      return {
        navData: {
          sortBy: 'vcdesc', //排序规则
          direction: 'horizontal', //商品样式horizontal:水平 vertical:垂直
          searchInfo: '', //搜索信息,
          sortList: [
            {
              label: '综合',
              value: ['vcdesc'],
            },
            {
              label: '销量',
              value: ['scdesc'],
            },
            {
              label: '价格',
              value: ['prdesc', 'prasc'],
            },
          ],
          showSearchPanel: false, //搜索框
        },
        ajaxInfo: {
          loading: true,
          finished: false,
        },
        pageData: {
          page: 1,
          size: 10,
        },
        filterObj: {
          keyword: '',
          categoryId: '',
          categoryLevel: '',
          brandId: '',
          properties: [],
          promotionId:[],
          productSource:''
        },
      }
    },
    created() {
      this.filterObj.brandId = !isNaN($HMD$.rParam('b')) ? $HMD$.rParam('b') : ''
      this.filterObj.categoryId = $HMD$.rParam('c') || ''
      this.filterObj.categoryLevel = $HMD$.rParam('level') || ''
      this.filterObj.keyword = $HMD$.rParam('k') || '' 
      this.filterObj.promotionId= $HMD$.rParam('promotionId')?$HMD$.rParam('promotionId').split(','):[]
      this.filterObj.showSubProduct=$HMD$.rParam('isSubPro')?true:false
      this.filterObj.showSubProduct=$HMD$.rParam('isSubPro')?true:false
      this.filterObj.productSource=$HMD$.rParam('source')==1?1:$HMD$.rParam('source')==2?2:""
      if (sessionStorage.getItem('viewProductHistory')) {
        this.viewHistory = JSON.parse(sessionStorage.getItem('viewProductHistory'))
        this.navData.direction = this.viewHistory.goodsDirection ? this.viewHistory.goodsDirection : 'horizontal'
      }
      this.init();
      this.changeSearchParams()
    },
    methods: {
      init() {
        //页面created 处理数据
      },
      navChange({ type, value }) {
        switch (type) {
          case 'sort':
            this.$set(this.navData, 'sortBy', value);
            this.changeSearchParams()
            break
          case 'direction':
            this.$set(this.navData, 'direction', value);
            break
          case 'search':
            this.$set(this.navData, 'showSearchPanel', true);
            break
          case 'sanguan':
            if(value){
                let searchActivityTagReq = {
                  screen: value.isScreen,
                  tagIdList: value.activeTags.map(function(str) { 
                    return Number(str) 
                  }),
                }
                this.filterObj.promotionId = value.promotionIds.map(function(str) {
                  return Number(str)
                }),
                this.pageData.searchActivityTagReq = searchActivityTagReq
                this.pageData.isYearProduct = true
                this.filterObj.showSubProduct = true
            }else{
                let searchActivityTagReq = null
                this.filterObj.promotionId = null
                this.pageData.searchActivityTagReq = searchActivityTagReq
                this.pageData.isYearProduct = false
                this.filterObj.showSubProduct = false
            }
            
            this.changeSearchParams()
            break
        }      
      },
      loadMore() {
        if (this.pageData.page != 1 && !this.ajaxInfo.finished) {
          this.getDataList()
        }
      },
      changeSearchParams(emitData = {}, closeSearchPanel = true) {      
        this.pageData.page = 1
        this.navData.showSearchPanel = !closeSearchPanel
        if (Object.keys(emitData).length > 0) {
          this.navData.searchInfo = emitData.filterDetail
          this.searchPannelInfo = emitData
        }
        this.getDataList()
      },
      //图片链接错误
      nofind_pic() {
        let img = event.srcElement
        img.src = '//image10.homedo.com/default/default-1x1.png'
        img.onerror = null
      },
    }
  }

}